import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Box, Button, Input, FormControl, Text, Flex, InputGroup, InputRightElement, Image, useBreakpointValue, useColorModeValue } from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import Swal from 'sweetalert2';
import { useColorMode } from "@chakra-ui/react";
import LoginController from "../../controllers/Login/LoginController";
import outstand from '../../assets/img/logo_outstand.png';

function Login() {
  const { toggleColorMode } = useColorMode();
  const [logoBase64, setLogoBase64] = useState(null);
  
  const convertBase64ToImage = (base64String) => {
    if (!base64String) return null;
    const base64Clean = base64String.replace(/^data:image\/\w+;base64,/, '');
    return `data:image/png;base64,${base64Clean}`;
  };

  useEffect(() => {
    const currentColorMode = localStorage.getItem('chakra-ui-color-mode');
    if (!currentColorMode) {
      toggleColorMode();
      localStorage.setItem('chakra-ui-color-mode', 'dark');
    }
  }, [toggleColorMode]);

  const [login, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const history = useHistory();

  const showToast = (icon, title) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    });
    Toast.fire({
      icon,
      title
    });
  };

  const handleLogin = async () => {
    if (!login || !password) {
      showToast("error", "Nome de usuário e senha são obrigatórios.");
      return;
    }

    try {
      const response = await LoginController.Login(login, password);
      console.log("Resposta do login:", response);

      if (response && response.result && response.result[0]) {
        const userData = response.result[0];
        
        // Armazena o token JWT sem o logo
        localStorage.setItem('username', login);
        localStorage.setItem('access_token', userData.jwt_token);
        
        // Armazena o logo separadamente
        if (userData.logo_base_64) {
          const convertedLogo = convertBase64ToImage(userData.logo_base_64);
          setLogoBase64(convertedLogo);
          localStorage.setItem('logo_base_64', convertedLogo);
        }
        
        // Aguardar um momento para garantir que o estado foi atualizado
        setTimeout(() => {
          history.push("/admin/dashboard/home/");
          window.location.reload();
        }, 100);
      } else {
        showToast("error", "Falha na autenticação. Verifique suas credenciais.");
      }
    } catch (error) {
      console.error("Erro no login:", error);
      showToast("error", "Falha na autenticação. Verifique suas credenciais.");
    }
  };

  // Determine if video should be shown based on screen size
  const showVideo = useBreakpointValue({ base: false, md: true });

  // Set background color based on the color mode
  const backgroundColor = useColorModeValue("white", "black");

  return (
    <Flex h="100vh" direction={{ base: "column", md: "row" }}>
      {/* Left side with video (only on larger screens) */}
      {showVideo && (
        <Box flex="1" position="relative" overflow="hidden">
          <video 
            autoPlay 
            loop 
            muted 
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              opacity: "0.7",
            }}
          >
            <source src={require("../../assets/movies/login_video.webm")} type="video/mp4" />
            Seu navegador não suporta a tag de vídeo.
          </video>
          <Image 
            src={outstand} 
            alt="Company Name" 
            position="absolute" 
            top="100px"  
            left="130px" 
            boxSize="650px" 
            objectFit="contain" 
            style={{ filter: "drop-shadow(4px 2px 0px white) drop-shadow(2px 2px 2px gray)" } }
          />
        </Box>
      )}

      {/* Right side with form */}
      <Flex
        flex="1"
        align="center"
        justify="center"
        bg={backgroundColor}
        color={useColorModeValue("black", "white")}
        p="10"
      >
        <Box maxW="400px" w="100%" textAlign="center">
          {logoBase64 && (
            <Image 
              src={logoBase64}
              alt="Customer Voice Logo" 
              mx="auto" 
              mb="4" 
              boxSize="150px" 
              objectFit="contain" 
              style={{ filter: "drop-shadow(4px 2px 1px ) drop-shadow(4px 2px 1px black)" }}
            />
          )}

          <Text fontSize="xl" fontWeight="bold" mb="4">
            Bem vindo ao Customer Voice
          </Text>
          <FormControl>
            <Input
              type="text"
              placeholder="Login"
              mb="2"
              size="md"
              value={login}
              onChange={(e) => setUsername(e.target.value)}
              bg="gray.800"
              color="white"
              _placeholder={{ color: "gray.400" }}
              id="login-input"
            />
            <InputGroup size="sm" mb="4">
              <InputRightElement>
                {showPassword ? (
                  <ViewOffIcon onClick={() => setShowPassword(!showPassword)} cursor="pointer" color="white" />
                ) : (
                  <ViewIcon onClick={() => setShowPassword(!showPassword)} cursor="pointer" color="black" />
                )}
              </InputRightElement>
              <Input
                type={showPassword ? "text" : "password"}
                placeholder="Senha"
                mb="2"
                size="md"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                bg="gray.800"
                color="white"
                _placeholder={{ color: "gray.400" }}
                id="password-input"
              />
            </InputGroup>
            <Button colorScheme="blue" size="md" w="full" onClick={handleLogin}>
              Acessar minha conta
            </Button>
            <Text mt="4">
              <a onClick={() => history.push("/recover")} style={{ color: "blue", textDecoration: "underline" }}>
                Esqueci minha senha
              </a>
            </Text>
          </FormControl>
        </Box>
      </Flex>
    </Flex>
  );
}

export default Login;
